import React, { useCallback, useEffect, useRef } from 'react'
import { Button, Form, Input } from 'antd'
import { useTranslation } from 'react-i18next';
import { useStore } from '../../store/store';
import { getPrimaryDark } from '../../constants/constants';
import { useCreateCustomTextVariable } from '../../hooks';
import { mutateInsertVariableInOrderArray } from '../../utils/variableOrderArray';

const selector = ({ addVariable, currentDocument }) => {
  return ({
    addVariable,
    accentColor: getPrimaryDark(currentDocument?.type === 'template'),
  })
}

const AddVariableForm = ({ injectVariableInText, setIsPopoverOpen, filteredOptions }) => {
  const { addVariable, accentColor } = useStore(selector);
  const { t } = useTranslation();
  const inputRef = useRef();
  const [form] = Form.useForm();
  const {
    mutate: createCustomTextVariable,
  } = useCreateCustomTextVariable();


  const handleFormSubmit = useCallback((event) => {
    if (!['Enter'].includes(event.key)) return;
    event.stopPropagation()
    event.preventDefault()
    form.submit()
  }, [form])

  useEffect(() => {
    window.addEventListener('keydown', handleFormSubmit, true);
    return () => {
      window.removeEventListener('keydown', handleFormSubmit, true);
    };
  }, [handleFormSubmit]);

  useEffect(() => {
    const frameId = requestAnimationFrame(() => {
      inputRef.current?.focus({ preventScroll: true })
    })
    return () => cancelAnimationFrame(frameId)
  }, [])

  const onFinish = (values) => {
    createCustomTextVariable({ name: values.name }, {
      onSuccess: (newVariable) => {
        addVariable(newVariable, (variables, variableKey, draft) => {
          injectVariableInText(variableKey, variables)
          mutateInsertVariableInOrderArray(draft, variableKey)
        })
      }
    })
  }

  return (
    <Form
      form={form}
      colon={false}
      layout='horizontal'
      validateMessages={{ required: "Champ obligatoire." }}
      onFinish={onFinish}
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      <Form.Item label="Nom"
        name="name"
        rules={[{ required: true }]}
        style={{
          marginBottom: 12
        }}
      >
        <Input
          placeholder='Nom de la variable'
          onClick={() => inputRef.current.focus()}
          ref={inputRef}
          style={{
            width: "100%"
          }}
        />
      </Form.Item>
      <div style={{
        display: "flex",
        justifyContent: 'end',
        gap: 8
      }}>
        <Button onClick={() => setIsPopoverOpen(false)}>
          {t('cancel')}
        </Button>
        <Button
          onClick={() => form.submit()}
          style={{
            backgroundColor: accentColor,
            color: 'white'
          }}>
          {t('create')}
        </Button>
      </div>
    </Form>
  )
}

export default AddVariableForm
